import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import clientReducer from '../features/clients/clientSlice';
import policyReducer from '../features/policies/policySlice';
import meetingsReducer from '../features/meetings/meetingsSlice';
import staffReducer from '../features/auth/staffSlice';
import onboardingReducer from '../features/auth/onboardingSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    clients: clientReducer,
    policies: policyReducer,
    meetings: meetingsReducer,
    staff: staffReducer,
    onboarding: onboardingReducer,
  },
});

export default store;